import { render, staticRenderFns } from "./EditCoins.vue?vue&type=template&id=0dfbe970&scoped=true&"
import script from "./EditCoins.vue?vue&type=script&lang=ts&"
export * from "./EditCoins.vue?vue&type=script&lang=ts&"
import style0 from "./EditCoins.vue?vue&type=style&index=0&id=0dfbe970&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dfbe970",
  null
  
)

export default component.exports